interface TableData {
  value: string;
  colspan?: number;
  align?: 'left' | 'center' | 'right' | 'justify' | 'char';
}

interface TableInterface {
  headers: Array<TableData>;
  rows: Array<{
    data: Array<TableData>;
  }>;
}

export const Table = ({ headers, rows }: TableInterface): JSX.Element => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse border border-slate-300">
        <thead>
          <tr>
            {headers.map((column: TableData) => (
              <th
                className="border border-slate-300 p-5 sm:p-2"
                colSpan={column.colspan}
                key={column.value}
              >
                {column.value}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index: number) => (
            <tr key={'row' + index}>
              {row.data.map((col: TableData) => (
                <td
                  className="border border-slate-300 p-5 sm:p-2"
                  key={col.value}
                  colSpan={col.colspan}
                  align={col.align}
                >
                  {col.value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
